// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cu-a";
export var fulfillmentFormRail = "_cu-9";
export var headerTitleRow = "_cu-c";
export var orderDetailsWrapper = "_cu-7";
export var orderLinkTrigger = "_cu-2";
export var paymentInformationGrid = "_cu-h";
export var paymentSummaryColumn = "_cu-i";
export var shipmentContainer = "_cu-b";
export var shipmentDetailsMainPane = "_cu-8";
export var shipmentNavigationCard = "_cu-5";
export var shipmentNavigationRail = "_cu-3";
export var shipmentNavigationRailHeader = "_cu-4";
export var shipmentSummaryFact = "_cu-e";
export var shipmentSummaryGrid = "_cu-d";
export var shipmentSummaryMetadataRow = "_cu-f";
export var shipmentSummaryTags = "_cu-g";
export var shipmentWorkspace = "_cu-0";
export var shipmentWorkspaceContent = "_cu-6";
export var shipmentWorkspaceHeader = "_cu-1";